import React from "react";

import Title from "../../components/Title/Title.js";
import Button from "../../components/Buttons/Buttons.js";

import "./Home.scss";

const Home = () => {

  const cards = [
    {
      index: 1,
      title: "Mesa de partes virtual ARBITRAJE  Y JPRD CARC PUCP",
      body: "Ingresa aquí si deseas presentar solicitudes, contestaciones, escritos y documentos en general.",
      height: "min",
      route: "/mesa_partes",
      icon: "/assets/icons/Cloud.svg",
    },
    {
      index: 2,
      title: "Consulta de expedientes",
      body: "Consulta el estado y avance de un arbitraje, una conciliación decisoria y un árbrito de emergencia, para lo cual necesitará conocer el número de expediente que corresponda.",
      height: "min",
      route: "/consulta_expedientes",
      icon: "/assets/icons/Stack_of_Paper.svg",
    },
  ];
  return (
    <div className="main-background">
      <div className="circles">
        {/* <div className="circles-circle"></div> */}
        <div className="circles-circle"></div>
        <div className="circles-circle"></div>
        <div className="circles-circle"></div>
      </div>
      <Title
        title="Sistema de Gestión Arbitral"
        subtitle="Mesa de Partes de uso exclusivo para la recepción de escritos relacionados con Arbitraje, JRD, Conciliación Decisoria y solicitudes dirigidas al Centro de Análisis y Resolución de Conflictos de la PUCP. Toda documentación que no se refiera estrictamente a estos procedimientos se tendrá por no presentada y no será tramitada."
        textColor="text-white"
      ></Title>
      {/* <div>
        <img src="/assets/main-background.svg" className="d-inline-block align-text-top" alt="ANÁLISIS Y RESOLUCIÓN DE CONFLICTOS PUCP"/>
      </div> */}
      <div style={{ marginTop: "2rem", paddingLeft: "25px", paddingRight: "25px" }}>
        <Button
          title="Ingreso a SIGEA PUCP"
          type="btn-rounded-primary"
          onButtonClick={() => window.location.href = 'https://sigeapucp.com/gestionarbitraje/pages/public/login'}
          color="btn-secondary"
        ></Button>
      </div>
    </div>
  );
};

export default Home;
